<template>
            <NavBar/>

    <div class="section" id="container">

     <div id="heading">Talent Coder</div>
     <div id="start">
        <div class="info">based on Earth</div>
        <div class="info">khalil tahraoui</div>
        <div class="info">available for hire </div>
     </div>
     <div id="fimg" ></div>
    </div>
</template>

<script>
import NavBar from './NavBar.vue';
    export default {
    name: "Home",
    components: { NavBar }
}
</script>